import React, { useEffect } from "react"
import { Col, Row } from "react-bootstrap"

import { checkIdExistsStatus } from "../../utils/check-id-exists"
import CheckBox from "../input/checkbox"

const WorkTypeFilter = ({
  config,
  workType,
  showWorkType,
  UpArrow,
  handleWorkTypeChange,
  setShowWorkType,
}) => {
  useEffect(() => {}, [workType])
  return (
    <Col lg={12} className="mb-2">
      <Row
        className={
          showWorkType ? "align-items-center mb-2" : "align-items-center mb-1"
        }
      >
        <Col xs={10}>
          <h5>Work Type</h5>
        </Col>
        <Col xs={2} className="text-right mb-2">
          <button
            className="no-outline no-border no-background"
            onClick={() => setShowWorkType(!showWorkType)}
          >
            <img
              src={UpArrow}
              alt="wdn-arrow"
              className={!showWorkType ? "up" : "down"}
            />
          </button>
        </Col>
        {showWorkType &&
          config.job_type &&
          config.job_type.map(type => (
            <Col key={type.id} lg={12}>
              <CheckBox
                label={type.name}
                value={type.id}
                filters={true}
                checked={checkIdExistsStatus(workType, type.id.toString())}
                onChange={handleWorkTypeChange}
              />
            </Col>
          ))}
      </Row>
      <div className="border-bottom mb-2"></div>
    </Col>
  )
}

export default WorkTypeFilter
